import { castEnum } from "../../../../utils/CommonUtils";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsBlockItem {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.id = model.id;
        this.props = model.props;
        this.linksTo = model.linksTo
            ? Object.assign(Object.assign({}, model.linksTo), { type: castEnum(model.linksTo.type) }) : undefined;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        const model = {
            id: this.id,
            props: this.props,
        };
        if (this.linksTo) {
            model.linksTo = this.linksTo;
        }
        return model;
    }
}
